'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

let ObjectVector = exports.ObjectVector = function () {

  /**
   * @param {Function} proto
   * @param {Object[]|*} instances
   */
  function ObjectVector(proto) {
    _classCallCheck(this, ObjectVector);

    this._proto = proto;
    this._vector = [];

    for (var _len = arguments.length, instances = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      instances[_key - 1] = arguments[_key];
    }

    this.add.apply(this, instances);
  }

  /**
   * Add new instances to collection
   * @param {Object[]|*} instances
   * @returns {ObjectVector}
   */


  _createClass(ObjectVector, [{
    key: 'add',
    value: function add() {
      for (var _len2 = arguments.length, instances = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        instances[_key2] = arguments[_key2];
      }

      for (let i in instances) {
        if (!instances.hasOwnProperty(i)) {
          continue;
        }

        let instance = instances[i];

        if (!(instance instanceof this._proto)) {
          throw new Error(`The object ${instance.constructor.name} is not an instance of ${this._proto.name}`);
        }

        this._vector.push(instance);
      }

      return this;
    }

    /**
     * Get collection of instances
     * @returns {Object[]}
     */

  }, {
    key: 'collection',
    get: function get() {
      return this._vector;
    }
  }]);

  return ObjectVector;
}();


//////////////////
// WEBPACK FOOTER
// ../~/deep-core/lib.compiled/Generic/ObjectVector.js
// module id = 373
// module chunks = 0